// The actions file containing the various methods to be invoked to get data for the nav menu
import { EXPERT_EASE_CATEGORIES } from '~/constants/pages/contentful'

const actions = {
  async fetchMenuArticles (params) {
    const guidesStore = useGuidesStore()
    const expertAnalysisStore = useExpertAnalysisStore()

    const verticals = params?.verticals || []
    const limit = verticals.length * 5
    const skip = 0

    // Both requests are started synchronously (before either is awaited) so that
    // getPostsByCategory's internal useRequestFetch() call still runs within the
    // SSR request context — calling it after crossing an unrelated `await` loses that context.
    const articlesPromise = guidesStore.fetchFeaturedArticlesByVertical(verticals, limit, skip).then(response => response?.items ?? [])

    const topNewsPromise = expertAnalysisStore.getPostsByCategory({
      categories: [
        'Top News',
        ...Object.keys(EXPERT_EASE_CATEGORIES)
      ],
      limit: 4
    }).then(response => {
      const news = response?.top_news

      if (!news) {
        return []
      }

      return [
        news.featured,
        ...(news.items || [])
      ]
    })

    const [articles, topNews] = await Promise.all([articlesPromise, topNewsPromise])

    const articlesByVertical = articles.reduce((result, value) => {
      const verticalValue = value.vertical === 'Health Insurance' && value.isOvhc
        ? 'Overseas Visitor Health Cover'
        : value.vertical

      if (!(verticalValue in result)) {
        result[verticalValue] = []
      }

      result[verticalValue].push(value)
      return result
    }, {})

    // Add the top news to Expert Analysis
    articlesByVertical['Expert Analysis'] = topNews

    // Set the updated state value
    // Note: no component currently reads `featuredMenu` or the `featuredMenuItems`
    // getter back out — NavBar calls this action for the fetch side effect only.
    this.$state.featuredMenu = articlesByVertical
  }
}

export default actions
